import { IAssignment, OrderStatus } from "@miplatform/types";
import { calculateMapZoomLevel } from "@miplatform/utils";
import { Theme } from "@mui/material";

export const getLocationBoundariesFromAssignments = (
  assignments: IAssignment[]
) => {
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLng = Infinity;
  let maxLng = -Infinity;

  let hasLocations = false;

  assignments.forEach((assignment) => {
    if (assignment.home?.address?.location) {
      const { location } = assignment.home.address;
      hasLocations = true;

      minLat = Math.min(minLat, location.latitude);
      maxLat = Math.max(maxLat, location.latitude);
      minLng = Math.min(minLng, location.longitude);
      maxLng = Math.max(maxLng, location.longitude);
    }
  });

  if (!hasLocations) {
    return {};
  }

  const latDiff = maxLat - minLat;
  const lngDiff = maxLng - minLng;
  const maxDiff = Math.max(latDiff, lngDiff);

  const zoomFactor = calculateMapZoomLevel(maxDiff);

  return {
    position: {
      lat: (minLat + maxLat) / 2,
      lng: (minLng + maxLng) / 2,
    },
    zoomFactor,
  };
};

export const getAssignmentMarker = (
  color: string,
  status: OrderStatus,
  theme: Theme
) => {
  const pinColor =
    status === OrderStatus.Complete
      ? theme.palette.green.medium
      : theme.palette.common.white;

  return `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path fill="${pinColor}" d="M24 6c-8.837 0-16 7.163-16 16s16 28 16 28s16-21.163 16-28s-7.163-16-16-16zm0 96c-3.314 0-6-2.686-6-6s2.686-6 6-6s6 2.686 6 6s-2.686 6-6 6z"/>
        <circle cx="24" cy="23" r="12" fill="${color}"/>
      </svg>`
  )}`;
};
